import Format from 'app/src/data/Format';
import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class Shop extends RetailModel {
  // Server uses the shopID field as the model's unique identifier. This
  // informs the Backbone.Model of this fact.
  get idAttribute() {
    return 'shopID';
  }

  get defaults() {
    return {
      archived: false,
      ccGatewayID: 0,
      contactID: 0,
      labelMsrp: false,
      labelTitle: '',
      name: '',
      receiptSetupID: 0,
      serviceRate: 0,
      taxCategoryID: 0,
      taxLabor: false,
      timeStamp: '',
      timeZone: '',
    };
  }

  get retailResponseName() {
    return 'Shop';
  }

  /**
   * Return the url for the Shop endpoint
   */
  url() {
    let URL = URLHelper.getAccountURL('/Shop');
    if (!this.isNew()) {
      URL += `/${this.id}`;
    }
    return `${URL}.json`;
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    let shop = super.parse(response);

    // the Cloud API has a tendency to send all values as strings so let's make sure they're of the proper type
    shop.shopID = Format.parseInt(shop.shopID);
    shop.archived = Format.parseBoolean(shop.archived);
    shop.ccGatewayID = Format.parseInt(shop.ccGatewayID);
    shop.contactID = Format.parseInt(shop.contactID);
    shop.labelMsrp = Format.parseBoolean(shop.labelMsrp);
    shop.receiptSetupID = Format.parseInt(shop.receiptSetupID);
    shop.serviceRate = Format.parseFloat(shop.serviceRate);
    shop.taxCategoryID = Format.parseInt(shop.taxCategoryID);
    shop.taxLabor = Format.parseBoolean(shop.taxLabor);

    return shop;
  }
}
